import axios from 'axios';
import authHeader from "@/service/auth-header";

class SystemConfigService {

    async getStatus() {
        return await axios.get(`/api/systemconfig/status`,{ headers: authHeader() })
    }

    async getFrontendBaseUrl() {
        return await axios.get(`/api/systemconfig/frontendbaseurl`,{ headers: authHeader() })
    }

    async getCallbackUrl() {
        return await axios.get(`/api/systemconfig/callbackurl`,{ headers: authHeader() })
    }

    async getPayfastServerUrl() {
        return await axios.get(`/api/systemconfig/payfastServerUrl`,{ headers: authHeader() })
    }

    async getDnaPaymentsPaymentAPIJsUrl() {
        return await axios.get(`/api/systemconfig/dnaPaymentsPaymentAPIJsUrl`,{})
    }

    async getStripeJsUrl() {
        return await axios.get(`/api/systemconfig/stripeJsUrl`,{})
    }
}

export default new SystemConfigService();
